import React from 'react';
import './course.css';
import img from '../assets/course-bg.png';
import HeroTwo from '../components/heroTwo/HeroTwo';
import SectionSeven from '../components/section-seven/SectionSeven';


function Course() {





    return (
        <div className='course__main'>
            <div>
             <HeroTwo 
            head='Courses'
            image={img}
            bgposition='top'
            bgsize='contain'
            />
        </div>

        <SectionSeven />
        </div>
    )
}

export default Course
